<template>
    <div class="UserStudentSchoolSelectSelect">
        <div class="UserStudentSchoolSelectSelect__item"
            v-for="(item, i) in state" :key="i"
        >
            <text-select
                class="UserStudentSchoolSelectSelect__item__select"
                :options="options"
                :name="`skola[${i}][school_key]`"
                :value="item.school_key"
            ></text-select>
            <label class="ml-3">
                absolvent
                <input type="hidden" :name="`skola[${i}][absolvent]`" value="0">
                <input type="checkbox"
                    :name="`skola[${i}][absolvent]`" value="1"
                    :checked="item.absolvent"
                />
            </label>
        </div>
        <button class="btn btn-outline-primary" @click.prevent="addSchool()">Přidat</button>
    </div>
</template>

<script>
    export default {
        props: [
            'options',
            'selected'
        ],

        data: () => ({
            state: []
        }),

        methods: {
            addSchool() {
                this.state.push({
                    school_key: null,
                    absolvent: false
                });
            }
        },

        mounted() {
            let that = this;

            if (this.selected === null) {
                this.addSchool();
                return;
            }

            this.selected.forEach((item) => {
                that.state.push({
                    school_key: item.school_key,
                    absolvent: !! parseInt(item.absolvent)
                })
            });
        }
    }
</script>

<style lang="scss">
    .UserStudentSchoolSelectSelect__item {
        display: flex;
        margin-right: .5rem;
        margin-bottom: .5rem;
    }
    .UserStudentSchoolSelectSelect__item__select {
        flex-grow: 2;
    }
</style>
